import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import TablePagination from "@mui/material/TablePagination";

export default class MUITablePagination extends ReactBrick {
    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const page = useProperty($, 'Page');
            const count = useProperty($, 'Count');
            const rowsPerPage = useProperty($, 'Page size');
            const rowsPerPageOptions = useProperty($, 'Page size options');

            const handleChangePage = (_, newPage) => {
                $.set('Page', newPage);
                $.trigger('On page change');
            };

            const handleChangeRowsPerPage = (event) => {
                $.set('Page size', parseInt(event.target.value, 10));
                $.trigger('On rows per page change');
            };

            return (
                <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage || 10}
                    rowsPerPageOptions={rowsPerPageOptions}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            );
        };
    }
}

registerBrick('019aa6117cd7228dd053', MUITablePagination);
